import {TopNav} from "../../components/TopNavigation";
import {
  AppLayout,
  BreadcrumbGroup,
  Button, ButtonDropdown,
  Container,
  ContentLayout,
  Header,
  Link,
  SpaceBetween,
  Textarea,
  TextContent
} from "@cloudscape-design/components-themed";
import {Navigation} from "../../components/Navigation";
import React, {useCallback, useState} from "react";
import {debounce} from "lodash";
import {NextPageContext} from "next";
import {useRouter} from "next/router";
import QRCode from "react-qr-code";

enum CopyStatus {READY = "Copy", COPYING = "Copying", COPIED = "Copied"}

export function getServerSideProps(ctx: NextPageContext) {
  return {
    props: {}
  }
}

function Breadcrumbs() {
  const breadcrumbItems = [
    {
      text: 'Home',
      href: '/',
    },
    {
      text: 'QR Code Generator',
      href: '/qr',
    },
  ];
  return <BreadcrumbGroup items={breadcrumbItems} expandAriaLabel="Show path" ariaLabel="Breadcrumbs"/>;
}

export default function Page() {
  const router = useRouter();
  const [value, setValue] = useState("");
  const [result, setResult] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");

  const runProcess = useCallback((data: string) => {
    setResult(data);
    setProcessing(false);
  }, [value]);

  const setValueDebounce = debounce((data) => {
    runProcess(data);
  }, 500);

  const [copyStatus, setCopyStatus] = useState(CopyStatus.READY);
  const onCopyClicked = useCallback((text: string) => {
    setCopyStatus(CopyStatus.COPYING);
    navigator.clipboard.writeText(text);
    setTimeout(() => {
      setCopyStatus(CopyStatus.COPIED);
    }, 200);
    setTimeout(() => {
      setCopyStatus(CopyStatus.READY);
    }, 1000);
  }, []);

  return (
    <>
      <TopNav/>
      <AppLayout
        content={
          <ContentLayout
            header={
              <Header
                variant="h1"
                info={
                  <Link variant="info" ariaLabel={'Information about text converter.'}/>
                }
              >
                QR Code Generator
              </Header>
            }
          >
            <SpaceBetween size="m">
              <Container>
                <SpaceBetween size="m">
                  <SpaceBetween size="s">
                    <SpaceBetween size="s" direction="horizontal">
                      <Header variant="h2">Input</Header>
                    </SpaceBetween>
                    <Textarea
                      value={value}
                      onChange={(event) => {
                        setProcessing(true);
                        setValue(event.detail.value);
                        setValueDebounce(event.detail.value)
                      }}
                    />
                  </SpaceBetween>
                  <SpaceBetween size="s" direction="horizontal">
                    <Button variant="primary" iconName="upload" onClick={_ => runProcess(value)}
                            loading={processing}>Convert</Button>
                    {error && <TextContent>{error}</TextContent>}
                  </SpaceBetween>
                  <SpaceBetween size="s">
                    <SpaceBetween size="s" direction="horizontal">
                      <Header variant="h2">Result</Header>
                    </SpaceBetween>
                    <SpaceBetween size="s" direction="horizontal">
                      <QRCode value={result}/>
                      <SpaceBetween size="s">
                        <Button>
                        <Button iconName="download">Save</Button>
                        <ButtonDropdown items={[
                          {text: "Save as PNG", id: "png"},
                          {text: "Save as JPG", id: "jpg"},
                          {text: "Save as SVG", id: "svg"},
                        ]}></ButtonDropdown>
                        </Button>
                      </SpaceBetween>
                    </SpaceBetween>
                    <SpaceBetween size="s" direction="horizontal">
                      <Textarea readOnly value={result}/>
                      <Button
                        iconName="copy"
                        onClick={() => onCopyClicked(result)}
                        loading={copyStatus == CopyStatus.COPYING}
                        disabled={copyStatus == CopyStatus.COPIED}
                      >
                        {copyStatus}
                      </Button>
                    </SpaceBetween>
                  </SpaceBetween>
                </SpaceBetween>
              </Container>
            </SpaceBetween>
          </ContentLayout>
        }
        headerSelector="#header"
        breadcrumbs={<Breadcrumbs/>}
        navigation={<Navigation/>}
        // tools={toolsContent}
        // toolsOpen={toolsOpen}
        // onToolsChange={({ detail }) => setToolsOpen(detail.open)}
        // ariaLabels={appLayoutLabels}
        // notifications={<Notifications />}
      />
    </>

  )
}
